const dataStatisticAttestationPartitionCoursesToDrawGraph = function (educationalAttestationStatistics, codes) {

  const _courses = [1, 2, 3, 4, 5, 6]
  const findCourseValue = function (courses, course) {
    return _.find(courses, (eduCourse) => {
      return eduCourse.course === course;
    })?.value || 0;
  }

  const findEducationProgram =  function (statistics, code) {
    return _.find(statistics, (statistic) => {
      return statistic.meta.educationProgramCode === code;
    });
  }

  const getCourseData = function (course, codes) {
    return _.map(codes, (code) => {
      const education_program = findEducationProgram(educationalAttestationStatistics, code);
      return findCourseValue(education_program.courses, course);
    });
  }


  const mapCoursesToData = function () {
    return _.map(_courses, (course) => {
      return {
        name: `${course} курс`,
        data: getCourseData(course, codes),
      };
    });
  }

  const mapCoursesToDataAndTotalValueData = function () {
    return _.map(mapCoursesToData(), (course) => {
      let calculateAverage = Number((_.sum(course.data)/_.compact(course.data).length).toFixed(2));
      if (_.isNaN(calculateAverage)) calculateAverage = 0;
      return {
        name: course.name,
        data: [...course.data, calculateAverage],
      };
    });
  }

  return mapCoursesToDataAndTotalValueData();

}

export default dataStatisticAttestationPartitionCoursesToDrawGraph